<template>
	<div>
		<div v-if="offer.location.hub">
			<paper-bid-edit
				:form="form"
				:active-futures="activeFutures"
				:trade="trade"
			/>
		</div>
		<div v-else>
			<bid-edit-step-1
				:form="form"
				:reference="offer"
				:trade="trade"
				:active-futures="activeFutures"
				:other-errors="otherErrors"
				:show-reference="false"
			/>
		</div>
	</div>
</template>
<script>
let options = require("../../cropOptions");
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		otherErrors: {
			type: Object,
			required: false,
		},
		trade: {
			type: String,
			required: true,
		},
	},
};
</script>
